import { trim } from "lodash-es";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

type PaperSizes = keyof typeof copy.event.pdf.fields.paperSizes;

const errors = copy.errors;

export const getFields = (): IFormFields => [
  {
    name: "title",
    label: copy.scheduleBlock.download.fields.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
      validate: (value: string) => !!trim(value) || errors.required,
    },
  },
  {
    name: "paperSize",
    type: IFieldType.radioGroup,
    label: copy.event.pdf.fields.paperSize,
    options: Object.keys(copy.event.pdf.fields.paperSizes).map((size) => ({
      value: size,
      label: copy.event.pdf.fields.paperSizes[size as PaperSizes],
    })),
    validation: {
      required: errors.required,
    },
  },
  {
    name: "intro",
    label: copy.scheduleBlock.download.fields.intro,
    type: IFieldType.rte,
  },
  {
    name: "showMyPersonalSchedule",
    type: IFieldType.checkbox,
    label: copy.scheduleBlock.download.fields.showMyPersonalSchedule,
    superLabel: copy.event.pdf.fields.other,
  },
];
